// This icon file is generated automatically.
var MenuUnfold2Outlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M.7 3.4a.7.7 0 01-.7-.7C0 2.3.32 2 .7 2h18.6a.7.7 0 110 1.4H.7zM.7 18a.7.7 0 01-.7-.7c0-.38.32-.7.7-.7h18.6a.7.7 0 110 1.4H.7zm17.62-8.19l-2.34-2.33a.7.7 0 010-.99.7.7 0 01.99 0l2.82 2.83a.7.7 0 010 .99L17 13.12a.7.7 0 01-1 0 .7.7 0 010-.99l2.33-2.32zM.7 10.52a.7.7 0 01-.7-.7c0-.38.31-.69.7-.69h14.12a.7.7 0 110 1.4H.7z" } }] }, "name": "menu-unfold2", "theme": "outlined" };
export default MenuUnfold2Outlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/MenuUnfold2Outlined.js
// module id = 3116
// module chunks = 0